export default __webpack_public_path__ + "static/doodle-underline-2-09c4b261fe30238ecf7621e0b414810d.svg";